(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  var selectors = {
    drawer: '[data-cart-drawer]',
    drawerItems: '[data-cart-items]',
    cartCount: '[data-cart-count]',
    subtotal: '[data-cart-subtotal]',
    shipping: '[data-free-shipping]',
    toast: '[data-store-toast]'
  };

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    return 'S/ ' + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function showToast(message) {
    var toast = document.querySelector(selectors.toast);
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(window.__storeToastTimer);
    window.__storeToastTimer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2800);
  }

  function cartUrl(suffix) { return root.replace(/\/$/, '/') + 'cart' + (suffix || ''); }

  function getCart() {
    return fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); });
  }

  function updateShipping(cart) {
    document.querySelectorAll(selectors.shipping).forEach(function (box) {
      var threshold = Number(box.getAttribute('data-threshold') || 7000);
      var subtotal = Number(cart.items_subtotal_price || 0);
      var remaining = Math.max(0, threshold - subtotal);
      var progress = Math.min(100, threshold ? subtotal / threshold * 100 : 100);
      var message = box.querySelector('[data-free-shipping-message]');
      var bar = box.querySelector('[data-free-shipping-progress]');
      var shippingDone = remaining === 0 && subtotal > 0;
      if (message) {
        message.innerHTML = shippingDone
          ? '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9.6 16.2 5.4 12 4 13.4l5.6 5.6L20.4 8.2 19 6.8z"/></svg> ¡Genial! Tu envío es <strong>gratis</strong>'
          : '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 5h11a1 1 0 0 1 1 1v9H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm13 4h3.2a1 1 0 0 1 .8.4l1.8 2.4a1 1 0 0 1 .2.6V15h-6V9ZM6.6 19.4a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm11 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/></svg> Te faltan <strong>' + money(remaining) + '</strong> para el envío gratis';
      }
      if (bar) bar.style.width = progress + '%';
      // La clase dispara la celebracion en CSS solo cuando cambia el estado
      if (shippingDone !== box.classList.contains('is-complete')) box.classList.toggle('is-complete', shippingDone);
    });
  }

  function itemMarkup(item) {
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
    return '<li class="cart-item" data-cart-line="' + escapeHtml(item.key) + '">' +
      '<a class="cart-item__image" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image || '') + '" alt="' + escapeHtml(item.title) + '"></a>' +
      '<div class="cart-item__content"><a class="cart-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title || item.title) + '</a>' + variant +
      '<div class="cart-item__price">' + money(item.final_line_price) + '</div>' +
      '<div class="cart-item__actions"><div class="qty-control"><button type="button" data-cart-decrease aria-label="Disminuir cantidad">−</button><span>' + item.quantity + '</span><button type="button" data-cart-increase aria-label="Aumentar cantidad">+</button></div><button type="button" class="cart-remove" data-cart-remove>Quitar</button></div></div></li>';
  }

  // ---- Cuenta atras de la zona de compra ----
  // Shopify NO reserva inventario por tener algo en el carrito, asi que el texto
  // dice "Completa tu compra en", no "reservado": no se afirma una reserva que
  // no existe. Al llegar a 00:00 no se toca el carrito, ni el checkout, ni
  // WhatsApp; solo se queda en 00:00.
  //
  // El vencimiento se guarda en sessionStorage y se lee una sola vez. La cuenta
  // vive en su propio intervalo, FUERA de renderCart, para que ningun cambio
  // AJAX (cantidad, quitar, abrir o cerrar el carrito) la reinicie.
  var CUENTA_CLAVE = 'cartBuyCountdownEnds';
  var CUENTA_MS = 3 * 60 * 1000;
  var cuentaFin = null;
  var cuentaTimer = null;

  function finDeCuenta() {
    if (cuentaFin) return cuentaFin;
    var guardado = null;
    // En navegacion privada o con cookies bloqueadas sessionStorage lanza
    try { guardado = window.sessionStorage.getItem(CUENTA_CLAVE); } catch (e) {}
    var fin = Number(guardado);
    if (!fin || !isFinite(fin)) {
      fin = Date.now() + CUENTA_MS;
      try { window.sessionStorage.setItem(CUENTA_CLAVE, String(fin)); } catch (e) {}
    }
    cuentaFin = fin;
    return fin;
  }

  function pintarCuenta() {
    var nodos = document.querySelectorAll('[data-cart-timer]');
    if (!nodos.length) return false;
    var restante = Math.max(0, finDeCuenta() - Date.now());
    var min = Math.floor(restante / 60000);
    var seg = Math.floor((restante % 60000) / 1000);
    var texto = (min < 10 ? '0' : '') + min + ':' + (seg < 10 ? '0' : '') + seg;
    nodos.forEach(function (nodo) { nodo.textContent = texto; });
    return restante > 0;
  }

  function initCuenta() {
    if (!document.querySelector('[data-cart-timer]')) return;
    pintarCuenta();
    cuentaTimer = window.setInterval(function () {
      if (!pintarCuenta()) { window.clearInterval(cuentaTimer); cuentaTimer = null; }
    }, 1000);
  }

  // ---- Boton "Continuar en WhatsApp" del carrito lateral ----
  // El mensaje se arma con el carrito que ya recibe renderCart, que es por donde
  // pasan TODOS los cambios (agregar, cambiar cantidad, quitar). Por eso siempre
  // refleja el estado actual sin tener que volver a pedir /cart.js.

  // money() puede venir de Shopify.formatMoney y traer entidades HTML segun el
  // formato de moneda de la tienda. En WhatsApp va texto plano, asi que se
  // convierte a texto antes de usarlo.
  function moneyPlain(cents) {
    var div = document.createElement('div');
    div.innerHTML = money(cents);
    return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function whatsappText(cart) {
    var MAX = 20; // tope para no generar una URL que WhatsApp no acepte
    var lineas = ['Hola \uD83D\uDC4B Quiero realizar este pedido:', ''];
    cart.items.slice(0, MAX).forEach(function (item) {
      var nombre = item.product_title || item.title || '';
      // La variante solo si corresponde: Shopify usa "Default Title" cuando no hay
      var variante = item.variant_title && item.variant_title !== 'Default Title'
        ? ' (' + item.variant_title + ')' : '';
      lineas.push('\u2022 ' + item.quantity + 'x ' + nombre + variante + ' \u2014 ' + moneyPlain(item.final_line_price));
    });
    if (cart.items.length > MAX) {
      lineas.push('\u2022 ... y ' + (cart.items.length - MAX) + ' producto(s) mas');
    }
    lineas.push('', 'Total: ' + moneyPlain(cart.items_subtotal_price), '', 'Quiero coordinar mi pedido por WhatsApp.');
    return lineas.join('\n');
  }

  // Normalmente Liquid ya entrega solo los digitos, pero si llegara una URL
  // entera hay que sacar el numero del sitio correcto: quitar "todo lo que no
  // sea digito" colaria el 0 de app_absent=0 al final y mandaria a un numero
  // que no existe.
  function telefono(bruto) {
    var v = String(bruto || '').trim();
    if (!v) return '';
    var m = /[?&]phone=(\d+)/.exec(v) || /wa\.me\/(\d+)/.exec(v);
    return m ? m[1] : v.replace(/\D/g, '');
  }

  function renderWhatsapp(cart) {
    document.querySelectorAll('[data-cart-whatsapp]').forEach(function (element) {
      element.hidden = cart.item_count < 1;
      var tel = telefono(element.getAttribute('data-wa-phone'));
      if (!tel || !cart.items || !cart.items.length) return;
      element.href = 'https://wa.me/' + tel + '?text=' + encodeURIComponent(whatsappText(cart));
    });
  }

  function renderCart(cart) {
    document.querySelectorAll(selectors.cartCount).forEach(function (element) { element.textContent = cart.item_count; element.hidden = cart.item_count < 1; });
    document.querySelectorAll(selectors.subtotal).forEach(function (element) { element.textContent = money(cart.items_subtotal_price); });
    document.querySelectorAll('[data-cart-checkout]').forEach(function (element) { element.hidden = cart.item_count < 1; });
    document.querySelectorAll('[data-cart-empty]').forEach(function (element) { element.hidden = cart.item_count > 0; });
    document.querySelectorAll(selectors.drawerItems).forEach(function (list) {
      if (!cart.items.length) {
        list.innerHTML = '<div class="cart-empty"><div><div class="cart-empty__icon"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 7V6a5 5 0 0 1 10 0v1h3.1l1 15H2.9l1-15H7Zm2 0h6V6a3 3 0 0 0-6 0v1Z"/></svg></div><h3>Tu carrito está esperando algo bonito</h3><p>Explora la tienda y encuentra ese producto que no sabías que querías.</p><a class="button button--dark" href="/collections/all" data-cart-close style="margin-top:18px">Seguir descubriendo</a></div></div>';
      } else {
        list.innerHTML = '<ul class="cart-items">' + cart.items.map(itemMarkup).join('') + '</ul>';
      }
    });
    document.querySelectorAll('[data-cart-item-count]').forEach(function (element) { element.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-buyzone]').forEach(function (element) { element.hidden = cart.item_count < 1; });
    renderWhatsapp(cart);
    updateShipping(cart);
  }

  function refreshCart() { return getCart().then(renderCart); }

  function openDrawer() {
    var drawer = document.querySelector(selectors.drawer);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
  }

  function closeDrawer() {
    var drawer = document.querySelector(selectors.drawer);
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
  }

  function addLine(variantId, quantity, buyNow) {
    var payload = { items: [{ id: Number(variantId), quantity: Number(quantity || 1) }] };
    return fetch(root.replace(/\/$/, '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (response) { if (!response.ok) throw new Error('add'); return response.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { if (buyNow) window.location.href = '/checkout'; else { openDrawer(); showToast(window.theme.strings.added); } });
  }

  function changeLine(key, quantity) {
    return fetch(root.replace(/\/$/, '/') + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) }).then(function (response) { return response.json(); }).then(renderCart);
  }

  function initDrawer() {
    document.querySelectorAll('[data-cart-open]').forEach(function (button) { button.addEventListener('click', function () { openDrawer(); refreshCart(); }); });
    document.querySelectorAll('[data-cart-close]').forEach(function (button) { button.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') { closeDrawer(); closeMobileMenu(); } });
  }

  function initAddToCart() {
    document.addEventListener('click', function (event) {
      var productIncrease = event.target.closest('[data-product-quantity-increase]');
      var productDecrease = event.target.closest('[data-product-quantity-decrease]');
      if (productIncrease || productDecrease) {
        event.preventDefault();
        var productForm = (productIncrease || productDecrease).closest('[data-product-form]');
        var quantityInput = productForm && productForm.querySelector('input[name="quantity"]');
        if (!quantityInput) return;
        var currentQuantity = Number(quantityInput.value || 1);
        var stepMax = Number(quantityInput.getAttribute('max')) || 5;
        quantityInput.value = Math.min(stepMax, Math.max(1, currentQuantity + (productIncrease ? 1 : -1)));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var quick = event.target.closest('[data-quick-add]');
      if (quick) {
        event.preventDefault();
        if (quick.disabled) return;
        quick.disabled = true;
        addLine(quick.getAttribute('data-variant-id'), 1, false).catch(function () { showToast(window.theme.strings.error); }).finally(function () { quick.disabled = false; });
      }
      var increase = event.target.closest('[data-cart-increase]');
      var decrease = event.target.closest('[data-cart-decrease]');
      var remove = event.target.closest('[data-cart-remove]');
      if (increase || decrease || remove) {
        var line = event.target.closest('[data-cart-line]');
        if (!line) return;
        var current = Number(line.querySelector('.qty-control span').textContent || 1);
        changeLine(line.getAttribute('data-cart-line'), remove ? 0 : Math.max(0, current + (increase ? 1 : -1)));
      }
    });
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var quantityInput = form.querySelector('input[name="quantity"]');
      var normalizeQuantity = function () {
        if (!quantityInput) return;
        var maxAttr = quantityInput.getAttribute('max');
        // Sin atributo max no imponemos tope: asi los formularios que ya existian
        // (oferta flash) se comportan igual que antes de este cambio.
        if (!maxAttr) return;
        var allowedMax = Number(maxAttr) || 5;
        quantityInput.value = Math.min(allowedMax, Math.max(1, Number(quantityInput.value || 1)));
      };
      if (quantityInput) {
        quantityInput.addEventListener('input', normalizeQuantity);
        quantityInput.addEventListener('change', normalizeQuantity);
      }
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        normalizeQuantity();
        var submit = form.querySelector('[type="submit"]');
        var buyNow = form.getAttribute('data-buy-now') === 'true';
        if (submit) submit.disabled = true;
        var data = new FormData(form);
        addLine(data.get('id'), data.get('quantity') || 1, buyNow).catch(function () { showToast(window.theme.strings.error); }).finally(function () { if (submit) submit.disabled = false; form.removeAttribute('data-buy-now'); });
      });
    });
    document.querySelectorAll('[data-buy-now]').forEach(function (button) {
      button.addEventListener('click', function () { var form = button.closest('form'); if (form) { form.setAttribute('data-buy-now', 'true'); form.requestSubmit(); } });
    });
  }

  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (countdown) {
      var end = new Date(countdown.getAttribute('data-end-date')).getTime();
      if (!end || Number.isNaN(end)) return;
      var tick = function () {
        var diff = Math.max(0, end - Date.now());
        var hours = Math.floor(diff / 3600000);
        var minutes = Math.floor(diff / 60000) % 60;
        var seconds = Math.floor(diff / 1000) % 60;
        countdown.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
        countdown.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
        countdown.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
        if (!diff) { countdown.closest('[data-flash-offer]').hidden = true; window.clearInterval(timer); }
      };
      var timer = window.setInterval(tick, 1000); tick();
    });
  }

  function initGallery() {
    var selectMedia = function (gallery, id) {
      if (!gallery || !id) return;
      var panels = gallery.querySelectorAll('[data-media-panel]');
      var thumbs = gallery.querySelectorAll('[data-media-thumb]');
      var matched = false;
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-media-panel') === String(id);
        panel.classList.toggle('is-active', active);
        if (!active) { var hidden = panel.querySelector('video'); if (hidden && typeof hidden.pause === 'function') hidden.pause(); }
        matched = matched || active;
      });
      thumbs.forEach(function (item) { item.classList.toggle('is-active', item.getAttribute('data-media-thumb') === String(id)); });
      return matched;
    };
    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-media-thumb]');
      if (!thumb) return;
      var gallery = thumb.closest('[data-product-gallery]');
      var id = thumb.getAttribute('data-media-thumb');
      selectMedia(gallery, id);
    });
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var first = gallery.querySelector('[data-media-panel]');
      if (first) selectMedia(gallery, first.getAttribute('data-media-panel'));
    });
    return selectMedia;
  }

  function initVariants(selectMedia) {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var json = form.closest('[data-product-root]') && form.closest('[data-product-root]').querySelector('[data-product-variants]');
      if (!json) return;
      var variants = JSON.parse(json.textContent || '[]');
      var selects = form.querySelectorAll('[data-option-select]');
      var initialVariantId = String(form.getAttribute('data-current-variant-id') || '');
      var initialized = false;
      var update = function () {
        var values = Array.prototype.map.call(selects, function (select) { return select.value; });
        var variant = !initialized && initialVariantId
          ? variants.find(function (item) { return String(item.id) === initialVariantId; })
          : selects.length === 0
          ? variants.find(function (item) { return String(item.id) === initialVariantId; })
          : variants.find(function (item) { return item.options.every(function (option, index) { return option === values[index]; }); });
        variant = variant || null;
        var idInput = form.querySelector('[name="id"]');
        var button = form.querySelector('[type="submit"]');
        var buyNow = form.querySelector('[data-buy-now]');
        var available = !!(variant && variant.available);
        if (idInput) idInput.value = variant ? variant.id : '';
        if (button) {
          // Solo la pagina de producto marca su boton con data-keep-label. El resto de
          // formularios (p. ej. la oferta flash de la portada) mantiene el texto de siempre.
          var keepLabel = button.hasAttribute('data-keep-label');
          if (keepLabel && !button.hasAttribute('data-label-default')) {
            button.setAttribute('data-label-default', (button.textContent || '').trim() || 'Agregar al carrito');
          }
          button.disabled = !available;
          if (available) {
            button.textContent = keepLabel ? button.getAttribute('data-label-default') : 'Agregar al carrito';
          } else {
            button.textContent = 'Agotado';
          }
        }
        if (buyNow) buyNow.disabled = !available;
        var price = form.closest('[data-product-root]').querySelector('[data-product-price]');
        var compare = form.closest('[data-product-root]').querySelector('[data-product-compare]');
        var saving = form.closest('[data-product-root]').querySelector('[data-product-saving]');
        var purchasePrice = form.closest('[data-product-root]').querySelector('[data-purchase-price]');
        var purchaseCompare = form.closest('[data-product-root]').querySelector('[data-purchase-compare]');
        if (variant && price) price.textContent = money(variant.price);
        if (variant && purchasePrice) purchasePrice.textContent = money(variant.price);
        if (compare) { compare.textContent = variant && variant.compare_at_price ? money(variant.compare_at_price) : ''; compare.hidden = !(variant && variant.compare_at_price && variant.compare_at_price > variant.price); }
        if (purchaseCompare) { purchaseCompare.textContent = variant && variant.compare_at_price ? money(variant.compare_at_price) : ''; purchaseCompare.hidden = !(variant && variant.compare_at_price && variant.compare_at_price > variant.price); }
        if (saving) { var discount = variant && variant.compare_at_price > variant.price ? Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) : 0; saving.textContent = discount ? 'AHORRA ' + discount + '%' : ''; saving.hidden = !discount; }
        var limitsNode = form.closest('[data-product-root]').querySelector('[data-quantity-limits]');
        var qtyInput = form.querySelector('input[name="quantity"]');
        if (limitsNode && qtyInput && variant) {
          var limits = {};
          try { limits = JSON.parse(limitsNode.textContent || '{}'); } catch (e) { limits = {}; }
          var variantMax = Number(limits[variant.id]) || 5;
          qtyInput.setAttribute('max', variantMax);
          if (Number(qtyInput.value) > variantMax) qtyInput.value = variantMax;
        }
        var gallery = form.closest('[data-product-root]') && form.closest('[data-product-root]').querySelector('[data-product-gallery]');
        var mediaId = variant && variant.featured_media && variant.featured_media.id;
        if (gallery && mediaId && selectMedia) selectMedia(gallery, mediaId);
        initialized = true;
      };
      Array.prototype.forEach.call(selects, function (select) { select.addEventListener('change', update); });
      update();
    });
  }

  function setMobileMenuState(isOpen) {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    menu.classList.toggle('is-open', isOpen);
    menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.classList.toggle('mobile-menu-open', isOpen);
    document.querySelectorAll('[data-menu-toggle]').forEach(function (button) {
      if (button.hasAttribute('aria-expanded')) button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
  function closeMobileMenu() { setMobileMenuState(false); }
  function initNavigation() {
    document.querySelectorAll('[data-search-toggle]').forEach(function (button) { button.addEventListener('click', function () { var panel = document.querySelector('[data-search-panel]'); if (panel) { panel.hidden = !panel.hidden; if (!panel.hidden) panel.querySelector('input').focus(); } }); });
    setMobileMenuState(false);
    document.querySelectorAll('[data-menu-toggle]').forEach(function (button) { button.addEventListener('click', function () { var menu = document.querySelector('[data-mobile-menu]'); if (menu) setMobileMenuState(!menu.classList.contains('is-open')); }); });
    document.querySelectorAll('[data-mobile-menu] a').forEach(function (link) { link.addEventListener('click', closeMobileMenu); });
  }

  function initPredictiveSearch() {
    document.querySelectorAll('[data-predictive-search]').forEach(function (input) {
      var results = input.closest('.search-form').querySelector('[data-search-results]');
      var timer;
      input.addEventListener('input', function () {
        window.clearTimeout(timer);
        var term = input.value.trim();
        if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
        timer = window.setTimeout(function () {
          fetch(root.replace(/\/$/, '/') + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6').then(function (response) { return response.json(); }).then(function (data) {
            var products = data.resources && data.resources.results && data.resources.results.products || [];
            results.innerHTML = products.length ? products.map(function (product) { return '<a href="' + escapeHtml(product.url) + '"><img src="' + escapeHtml(product.featured_image && product.featured_image.url || '') + '" alt="' + escapeHtml(product.title) + '"><span><span class="predictive-results__name">' + escapeHtml(product.title) + '</span><span class="predictive-results__price">' + escapeHtml(product.price) + '</span></span></a>'; }).join('') : '<div style="padding:16px;color:var(--muted);font-size:.78rem">No encontramos productos para esta búsqueda.</div>';
            results.hidden = false;
          }).catch(function () { results.hidden = true; });
        }, 250);
      });
    });
  }

  // Contador de "personas viendo". Estado por producto: se guarda el id que se
  // inicializo, se cancela cualquier temporizador anterior y siempre se arranca
  // desde el primer valor de la lista. Nada de esto se activa fuera de la pagina
  // de producto, porque [data-product-viewers] solo existe en main-product.liquid.
  var viewerTimer = null;
  var viewerObserver = null;

  function stopViewers() {
    if (viewerTimer) { window.clearTimeout(viewerTimer); viewerTimer = null; }
  }

  function initViewers() {
    stopViewers();
    var box = document.querySelector('[data-product-viewers]');
    if (!box) return;
    var counter = box.querySelector('[data-viewer-count]');
    if (!counter) return;

    var values = (box.getAttribute('data-viewer-values') || '').split(',').map(function (value) {
      return parseInt(String(value).trim(), 10);
    }).filter(function (value) { return !isNaN(value) && value > 0; });
    if (!values.length) return;

    // Marca de que producto es este estado. Si el DOM cambia de producto, la
    // cadena de temporizadores anterior se detecta obsoleta y muere.
    var productId = box.getAttribute('data-viewer-product') || '';
    box.setAttribute('data-viewer-active', productId);

    var index = 0;
    counter.textContent = values[0];
    if (values.length < 2) return;

    var minSeconds = Number(box.getAttribute('data-viewer-min')) || 15;
    var maxSeconds = Number(box.getAttribute('data-viewer-max')) || 30;
    if (minSeconds < 1) minSeconds = 1;
    if (maxSeconds < minSeconds) maxSeconds = minSeconds;

    var schedule = function () {
      var delay = (minSeconds + Math.random() * (maxSeconds - minSeconds)) * 1000;
      viewerTimer = window.setTimeout(function () {
        if (!box.isConnected || box.getAttribute('data-viewer-active') !== productId) return;
        if (document.visibilityState !== 'hidden') {
          index = (index + 1) % values.length;
          counter.textContent = values[index];
        }
        schedule();
      }, delay);
    };
    schedule();
  }

  // Vuelve a arrancar cuando el navegador restaura la pagina desde su cache
  // (atras/adelante no dispara DOMContentLoaded) o cambia el historial.
  function watchViewers() {
    if (!document.querySelector('[data-product-viewers]')) return;
    window.addEventListener('pageshow', function () { initViewers(); });
    window.addEventListener('popstate', function () { initViewers(); });
    // Si otro producto se inyecta sin recargar, reinicializa con su propio id.
    if (viewerObserver || !('MutationObserver' in window)) return;
    viewerObserver = new MutationObserver(function () {
      var current = document.querySelector('[data-product-viewers]');
      if (!current) { stopViewers(); return; }
      var id = current.getAttribute('data-viewer-product') || '';
      if (current.getAttribute('data-viewer-active') !== id) initViewers();
    });
    viewerObserver.observe(document.body, { childList: true, subtree: true });
  }

  function initShare() { document.querySelectorAll('[data-share]').forEach(function (button) { button.addEventListener('click', function () { if (navigator.share) navigator.share({ title: document.title, url: window.location.href }); else navigator.clipboard && navigator.clipboard.writeText(window.location.href).then(function () { showToast('Enlace copiado'); }); }); }); }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer(); initAddToCart(); initCountdowns(); initCuenta(); var selectMedia = initGallery(); initVariants(selectMedia); initNavigation(); initPredictiveSearch(); initShare(); initViewers(); watchViewers();
    refreshCart().catch(function () {});
  });
})();
